/* unplugin-vue-components disabled */import script from "./StageRolesBar.vue?vue&type=script&setup=true&lang=js"
export * from "./StageRolesBar.vue?vue&type=script&setup=true&lang=js"

import "./StageRolesBar.vue?vue&type=style&index=0&id=ee7a9bbc&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee7a9bbc"]])

export default __exports__